import { FinancingSerializer } from './FinancingSerializer';
import { StockSerializer } from './StockSerializer';

class BaseProductSerializer {
  static deSerialize(data) {
    const financingData = data.PrecioVigente || [];
    const brand = data.Marca ? (data.Marca.MarNombre || null) : null;
    const [coverImageData, ...productImageData] = (data.ArticulosImagenes || []);
    return {
      ableToSell: data.HabilitadoVenta || false,
      brand,
      code: data.ArtCodigo,
      coverImage: (coverImageData || {}).AImImagen || null,
      financing: FinancingSerializer.deSerialize(financingData),
      id: String(data.ArtId),
      inWeb: data.ArtEnWeb,
      isService: data.ArtEsServicio || false,
      images: productImageData.map(imageData => (imageData || {}).AImImagen || null),
      name: data.ArtNombre,
      condition: data.ArtCondicion,
      stockLevel: StockSerializer.deSerialize(data.Stock),
      label: data.DestaqueWeb || null,
      labelColor: data.DestaqueWebColor || null,
      notAbleToSellString: data.ArticuloVienenTextoWeb || null,
      maxAmountToSell: data.ArtCantMaxVentaWeb || null,
      inUse: data.ArtEnUso !== undefined ? data.ArtEnUso : true,
      specificId: data.IdEspecifico || null,
    };
  }
}

export { BaseProductSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/BaseProductSerializer.js